// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { years } from "store/utils/years";
import { capexMonths } from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// subscriber acquisition assumption' keys
export const CAPEX_KEY = "capex";

export const initialState = {
  [CAPEX_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    months: capexMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 3,
      [years.YEAR_3_KEY]: 4,
      [years.YEAR_4_KEY]: 5,
      [years.YEAR_5_KEY]: 0,
    },
  },
};

// ==============================|| CAPEX ASSUMPTIONS REDUCER ||============================== //

const capexAssumptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CAPEX_ASSUMPTION_BY_YEAR:
      let newState = {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
      return newState;
    case actionTypes.SET_CAPEX_ASSUMPTION_BY_MONTH:
      let newStateMonths = {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
      return newStateMonths;
    case actionTypes.RESET_CAPEX_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default capexAssumptionsReducer;
